export const FINANCIAL_PANEL_BASE = '/panel/financial';
export const FINANCIAL_ENTRY_PANEL_BASE = `${FINANCIAL_PANEL_BASE}/entry`;

export const financialEntryRoutes = {
  list: FINANCIAL_ENTRY_PANEL_BASE,
  new: `${FINANCIAL_ENTRY_PANEL_BASE}/new`,
  edit: (id: number | string) => `${FINANCIAL_ENTRY_PANEL_BASE}/${id}/edit`,
};

export const isFinancialEntryFormPath = (pathname: string) =>
  pathname.includes(`${FINANCIAL_ENTRY_PANEL_BASE}/new`) ||
  /\/panel\/financial\/entry\/\d+\/edit/.test(pathname);

export const isFinancialEntryEditPath = (pathname: string) =>
  /\/panel\/financial\/entry\/\d+\/edit/.test(pathname);
